import {
  apiUrl,
  getList,
  deleteRecord,
  getSingleRecord,
  saveRecord,
  getStatsData,
  getAll,
  deleteAction,
  getAuditData,
  postAction,
  exportData,
  get,
  upload,
} from './apiUtils';
import type { ApiListParamsWithUnderscores, ApiExportParams } from '../types/api/listParams';
import type { ListApiResponse } from '../types/apiResponse';
import type { Stats } from '../types/stats';
import type { PlatformModel } from '../types/api';

const baseUrl = apiUrl + '/platforms/';

export function getAllPlatforms(): Promise<PlatformModel[]> {
  return getAll(baseUrl);
}

export function getPlatforms(
  params?: ApiListParamsWithUnderscores
): Promise<ListApiResponse<PlatformModel>> {
  return getList(`${baseUrl}search`, params);
}

export function getPlatformById(id: string): Promise<PlatformModel> {
  return getSingleRecord(baseUrl, id);
}

export function savePlatform(platform: Partial<PlatformModel>): Promise<{ id: string }> {
  return upload(baseUrl, platform);
}

export function deletePlatform(id: string): Promise<{ id: string }> {
  return deleteRecord(baseUrl, id);
}

export function getStats(id: string): Promise<Stats> {
  return getStatsData(baseUrl, id);
}

export function getStatsByDay(id: string): Promise<Stats> {
  return get(`${baseUrl}${id}/statsByDay/`);
}

export function getAggregateStats(
  id: string,
  from: Date,
  to: Date
): Promise<Stats> {
  const fromStr = from.toISOString().split('T')[0];
  const toStr = to.toISOString().split('T')[0];
  return get(`${baseUrl}${id}/aggregateStats?fromDate=${fromStr}&toDate=${toStr}`);
}

export function getAudit(id: string): Promise<unknown> {
  return getAuditData(baseUrl, id);
}

export function addAudit(id: string, comment: string): Promise<unknown> {
  return postAction(`${baseUrl}${id}/audit`, { comment });
}

export function getKeyProvidersForPlatform(id: string): Promise<unknown[]> {
  return getAll(`${baseUrl}${id}/keyProviders`);
}

export function savePlatformKeyProvider(
  platformId: string,
  keyProviderId: string
): Promise<{ id: string }> {
  return saveRecord(`${baseUrl}${platformId}/keyProvider/`, { keyProviderId });
}

export function deletePlatformKeyProvider(
  platformId: string,
  keyProviderId: string
): Promise<{ id: string }> {
  return deleteAction(`${baseUrl}${platformId}/keyProvider/${keyProviderId}`);
}

export function exportPlatformData(params: ApiExportParams): Promise<void> {
  return exportData(`${apiUrl}/export/platforms/search`, 'name', params);
}
